module.exports = __webpack_public_path__ + "static/img/logo.bb199d57.png";